import React from 'react';
import { Button } from '../../../../../components/ui/Button';
import { AppIcon } from '../../../../../components/icons/AppIcon';
import { ImportStats, ImportError } from '../types';
import { cn } from '@/lib/utils';

interface ResultStepProps {
    stats: ImportStats;
    errors: ImportError[];
    onClose: () => void;
}

export const ResultStep: React.FC<ResultStepProps> = ({ stats, errors, onClose }) => {
    const downloadErrorLog = () => {
        if (errors.length === 0) return;

        const bom = '\uFEFF';
        const csvContent =
            bom +
            'Linha,Nome,Motivo do Erro\n' +
            errors
                .map(
                    (e) =>
                        `${e.row},"${e.name.replace(/"/g, '""')}","${e.reason.replace(/"/g, '""')}"`,
                )
                .join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
            'download',
            `erros_importacao_${new Date().toISOString().split('T')[0]}.csv`,
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const ok = stats.success > 0;

    return (
        <div className="py-s8 text-center">
            <div
                className={cn(
                    'mx-auto mb-s4 flex size-16 items-center justify-center rounded-full',
                    ok ? 'bg-success-bg text-success-text' : 'bg-danger-bg text-danger-text',
                )}
                aria-hidden
            >
                <AppIcon name={ok ? 'check' : 'alert-triangle'} className="size-8" />
            </div>

            <h3 className="mb-s2 text-xl font-semibold text-default">Importação Concluída</h3>

            <dl className="mx-auto mt-s6 grid max-w-sm grid-cols-2 gap-s4">
                <div className="rounded-lg bg-success-bg p-s4">
                    <dt className="text-xs font-semibold uppercase tracking-wide text-success-text">
                        Sucessos
                    </dt>
                    <dd className="mt-s1 font-mono text-2xl font-semibold tabular-nums text-success-text">
                        {stats.success}
                    </dd>
                </div>
                <div className="rounded-lg bg-danger-bg p-s4">
                    <dt className="text-xs font-semibold uppercase tracking-wide text-danger-text">
                        Falhas
                    </dt>
                    <dd className="mt-s1 font-mono text-2xl font-semibold tabular-nums text-danger-text">
                        {stats.error}
                    </dd>
                </div>
            </dl>

            {stats.error > 0 && (
                <div className="mt-s6 flex flex-col items-center">
                    <p className="mb-s3 text-sm text-secondary">
                        Muitas falhas geralmente indicam contatos duplicados. Baixe o relatório para ver detalhes.
                    </p>
                    <Button
                        type="button"
                        variant="secondary"
                        onClick={downloadErrorLog}
                        className="min-h-11 gap-s2 text-sm touch-manipulation"
                    >
                        <AppIcon name="download" className="size-4" aria-hidden />
                        Baixar Relatório de Erros (.csv)
                    </Button>
                </div>
            )}

            <div className="mt-s8">
                <Button
                    type="button"
                    onClick={onClose}
                    className="min-h-11 w-full max-w-xs touch-manipulation"
                >
                    Fechar
                </Button>
            </div>
        </div>
    );
};
